/* eslint-disable react-native/no-inline-styles */
import * as S from './styles';
import React from 'react';
import {yupResolver} from '@hookform/resolvers/yup';
import theme from '../../../global/styles/theme';
import TextDefault from '../../../components/TextDefault';
import Button from '../../../components/Button';
import Input from '../../../components/Input';
import {useForm} from 'react-hook-form';
import {schemaLogin} from '../../../utils/schema';
import {useDispatch, useSelector} from 'react-redux';
import {useState} from 'react';
import {signIn} from '../../../services/auth';
import Toast from 'react-native-toast-message';
import {CommonActions, useNavigation} from '@react-navigation/native';

import {updateUser} from '../../../store/modules/user/actions';
import {Alert, Platform} from 'react-native';
// import ReactNativeBiometrics, {BiometryTypes} from 'react-native-biometrics';
import {Digital, FaceId} from '../../../../assets';
import {RootState} from '../../../store';
import KeyboardScrollView from '../../../components/KeyboardScrollView';
import {StatusBarContainer} from '../../../components/StatusBar';
import {toastConfig} from '../../../components/Toast';

const loginResolver = {
  resolver: yupResolver(schemaLogin),
};

export default function LoginScreen() {
  const {
    control,
    handleSubmit,
    formState: {errors},
  } = useForm(loginResolver);
  const userInfo = useSelector((state: RootState) => state?.user?.user);
  const navigation: any = useNavigation();
  const appTheme = useSelector((state: RootState) => state.config.appTheme);
  const biometric = useSelector((state: RootState) => state.config.biometric);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  async function handleLoginPress(data: any) {
    // const dataUser = {
    //   id: 1,
    //   name: 'Tester',
    //   email: 'tester@gmail.com',
    //   birthdate: '25/08/1995',
    //   cpf: '834.717.550-04',
    //   token: '123',
    //   tokenRefresh: '123123',
    //   publicKey: '',
    // };
    // // @ts-ignore
    // dispatch(updateUser(dataUser));
    // return navigation.dispatch(
    //   CommonActions.reset({
    //     index: 0,
    //     routes: [{name: 'MainTab'}],
    //   }),
    // );
    setIsLoading(true);
    await signIn(data)
      .then(async loginInfo => {
        setIsLoading(false);
        const dataUser = loginInfo?.data?.result;
        // @ts-ignore
        dispatch(updateUser(dataUser));
        return navigation.dispatch(
          CommonActions.reset({
            index: 0,
            routes: [{name: 'MainTab'}],
          }),
        );
      })
      .catch(error => {
        setIsLoading(false);
        Toast.show({
          type: 'error',
          text1:
            error?.response?.data?.message ||
            'Ocorreu um erro, tente novamente mais tarde!',
        });
      });
  }
  // const authBiometrics = async (biometrics: ReactNativeBiometrics) => {
  //   try {
  //     const {keysExist} = await biometrics.biometricKeysExist();
  //     if (keysExist) {
  //       await biometrics.deleteKeys();
  //     }
  //     const {success} = await biometrics.simplePrompt({
  //       promptMessage: `Confirme ${
  //         Platform.OS === 'android' ? 'Biometria' : 'Facial ID'
  //       }`,
  //     });
  //     if (success) {
  //       const {publicKey} = await biometrics.createKeys();
  //       const dataUser = {
  //         id: 1,
  //         name: 'Tester',
  //         email: 'tester@gmail.com',
  //         birthdate: '25/08/1995',
  //         cpf: '834.717.550-04',
  //         token: '123',
  //         tokenRefresh: '123123',
  //         publicKey,
  //       };
  //       // @ts-ignore
  //       dispatch(updateUser(dataUser));
  //       return navigation.dispatch(
  //         CommonActions.reset({
  //           index: 0,
  //           routes: [{name: 'MainTab'}],
  //         }),
  //       );
  //     } else {
  //       return Alert.alert('Ocorreu um erro', 'Tente novamente mais tarde.');
  //     }
  //   } catch (error) {
  //     Alert.alert('Ocorreu um erro', `${error}`);
  //   }
  // };

  // const verifyBiometrics = async () => {
  //   const biometrics = new ReactNativeBiometrics({
  //     allowDeviceCredentials: true,
  //   });
  //   biometrics.isSensorAvailable().then(resultObject => {
  //     const {available, biometryType} = resultObject;

  //     // Alert.alert('biometryType', `${biometryType} - ${available}`);

  //     if (available && biometryType === BiometryTypes.FaceID) {
  //       authBiometrics(biometrics);
  //       biometrics.createSignature({
  //         promptMessage: 'Login',
  //         payload: 'Authenticate with biometrics to login.',
  //       });
  //     } else if (available && biometryType === BiometryTypes.TouchID) {
  //       biometrics.createSignature({
  //         promptMessage: 'Login',
  //         payload: 'Authenticate with biometrics to login.',
  //       });
  //       authBiometrics(biometrics);
  //     } else {
  //       Alert.alert(
  //         'Aviso',
  //         `${
  //           Platform.OS === 'ios'
  //             ? 'FaceID não suportado'
  //             : 'Biometrica não suportada'
  //         }`,
  //       );
  //     }
  //   });
  // };

  return (
    <>
      <StatusBarContainer />
      <S.Container>
        <S.ContainerArea appTheme={appTheme}>
          <KeyboardScrollView>
            <S.Body>
              <S.Column style={{alignItems: 'flex-start'}}>
                <TextDefault
                  fontSize={32}
                  color={theme.colors(appTheme).white}
                  marginBottom={20}
                  text="Login"
                  fontFamily={theme.fonts.family.opensans.semi_bold}
                />
              </S.Column>
                <S.Column>
                  <Input
                    title="CPF/CNPJ"
                    errors={errors}
                    placeholder="Digite seu cpf/cnpj"
                    control={control}
                    name="document"
                    width="100%"
                    marginTop={10}
                    hideBorder
                    mask="cpfOrCnpj"
                    keyboardType="phone-pad"
                    // initialValue={userInfo?.user?.document || '108.389.624-59'}
                    initialValue={userInfo?.user?.document || ''}
                  />
                  <Input
                    title="Senha"
                    errors={errors}
                    placeholder="Digite sua senha"
                    control={control}
                    name="password"
                    type="password"
                    width="100%"
                    marginTop={10}
                    hideBorder
                    // initialValue="123iop"
                  />
                </S.Column>
                <S.Footer>
                  <TextDefault
                    fontSize={12}
                    color={theme.colors(appTheme).mainText}
                    text="Esqueceu a senha?"
                    fontFamily={theme.fonts.family.opensans.regular}
                    onPress={() => navigation.navigate('RecoverScreen')}
                    marginTop={20}
                  />
                </S.Footer>
                <Button
                  title="ENTRAR"
                  onPress={handleSubmit(handleLoginPress)}
                  fontFamily={theme.fonts.family.opensans.bold}
                  marginTop={40}
                  marginBottom={40}
                  isLoading={isLoading}
                  width="90%"
                />
                {/* {!biometric ? null : (
                  <S.ButtonBiometrics onPress={verifyBiometrics}>
                    <S.ImgBiometrics
                      source={Platform.OS === 'android' ? Digital : FaceId}
                      style={{tintColor: theme.colors(appTheme).mainText}}
                    />
                    <TextDefault
                      fontSize={12}
                      color={theme.colors(appTheme).mainText}
                      text="Entre utilizando sua"
                      marginTop={5}
                      fontFamily={theme.fonts.family.opensans.regular}
                    />
                    <TextDefault
                      fontSize={12}
                      color={theme.colors(appTheme).mainText}
                      text={
                        Platform.OS === 'android'
                          ? 'identificação biométrica'
                          : 'identificação facial'
                      }
                      fontFamily={theme.fonts.family.opensans.regular}
                    />
                  </S.ButtonBiometrics>
                )} */}
                <S.Footer>
                  <TextDefault
                    fontSize={12}
                    color={theme.colors(appTheme).mainText}
                    text="Criar uma Conta DSS Exchange"
                    fontFamily={theme.fonts.family.opensans.regular}
                    textAlign="center"
                    onPress={() => navigation.navigate('RegisterScreen')}
                  />
                </S.Footer>
            </S.Body>
          </KeyboardScrollView>
        </S.ContainerArea>
        <Toast config={toastConfig} />
      </S.Container>
    </>
  );
}
